import { makeStyles } from "@material-ui/core/styles";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";
import styles from "assets/jss/style-component/components/panelBodyStyle.js";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(styles);

export default function PanelBody(props) {
  const { children, ...rest } = props;
  const cardClasses = estilos(useStyles(), props, "body");

  return (
    <div className={cardClasses} {...rest}>
      {children}
    </div>
  );
}

PanelBody.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  children: PropTypes.node
};
